import * as React from 'react';

// tslint:disable-next-line: no-any
export default function(Component: any) {
  // tslint:disable-next-line: no-any
  return class ScrollToTop extends React.Component<any> {
    public componentDidMount() {
      window.scrollTo(0, 0);
    }
    public render() {
      return <Component {...this.props} />;
    }
  };
}
